import { clientbookApi } from '../core/clientbook-api';

/**
 * Generate an AI-suggested chat message reply.
 * Calls clientbook-api directly (POST /api/v1/ai/chat/message), mirroring what the
 * dashboard-backend /xa/chatMessages/:merchantId/generateChatResponse proxy forwarded.
 *
 * @param {Object} options
 * @param {Array}  options.chatMessages - Recent messages as [{ role, content }]
 * @param {number|string} options.storeId
 * @param {number|string} options.clientId
 * @param {Object} [options.axiosConfig] - Extra axios config (e.g. { cancelToken })
 */
export const generateChatMessage = async ({ chatMessages, storeId, clientId, axiosConfig = {} }) => {
  return clientbookApi.post({
    url: '/ai/chat/message',
    data: { chatMessages, storeId, clientId },
    axiosConfig,
  });
};

/**
 * Generate an AI-suggested reply to a Google review.
 * Calls clientbook-api directly (POST /api/v1/ai/google/reviews/:reviewId/reply).
 *
 * @param {Object} options
 * @param {number|string} options.reviewId
 * @param {Object} [options.axiosConfig] - Extra axios config (e.g. { cancelToken })
 */
export const generateGoogleReviewResponse = async ({ reviewId, axiosConfig = {} }) => {
  return clientbookApi.post({
    url: `/ai/google/reviews/${reviewId}/reply`,
    axiosConfig,
  });
};
